export default __webpack_public_path__ + "static/media/DS.77396619.png";